/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import './assets/less/main.less';
import './assets/less/error.less';
import Layout from './src/components/Layout';

const createPathHistory = (referrer, fullPath) => {
  const startIndex = fullPath.indexOf('/', 8);
  const partOfUrl = fullPath.slice(startIndex);
  let urlWithReferrer = partOfUrl;

  if (referrer !== '') {
    urlWithReferrer = `${partOfUrl} (${referrer})`;
  }
  return urlWithReferrer;
};

const createReferrer = () => {
  window.locations = window.locations || [document.referrer];
  window.locations.push(window.location.href);
  const referrer = window.locations[locations.length - 2];
  return referrer;
};

const addDataToLocalStorage = urlWithReferrer => {
  const localStorageData = JSON.parse(localStorage.getItem('visited-page'));
  const pathhistory = localStorageData || [];

  if (!pathhistory.includes(urlWithReferrer)) {
    pathhistory.push(urlWithReferrer);
  }
  localStorage.setItem('visited-page', JSON.stringify(pathhistory));

  const formattedPages = localStorage['visited-page']
    .replace(/[\[\]"]+/g, '')
    .split(',');
  if (formattedPages.length >= 1000) {
    localStorageData.splice(249, 500);
    localStorage.setItem('visited-page', JSON.stringify(localStorageData));
  }
};

export const onRouteUpdate = ({ location }) => {
  // the following calls a function in gatsby-ssr to create popups
  // eslint-disable-next-line camelcase
  if (typeof load_js === 'function') load_js();

  const referrer = createReferrer();
  const urlWithReferrer = createPathHistory(referrer, location.href);
  addDataToLocalStorage(urlWithReferrer);
};

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    // eslint-disable-next-line no-unused-expressions
    import(`intersection-observer`);
  }
};

function isBlogTopicPage(location) {
  const path = location.pathname;
  return path.startsWith('/blog/topic/') || path === '/blog/';
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const preserveScroll = isBlogTopicPage(location);
  return !preserveScroll;
};

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  if (isBlogTopicPage(props.location)) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Layout title="Blog - Ulam Labs" {...props}>
        {element}
      </Layout>
    );
  }
  // const withProps = React.cloneElement(element, props);
  // return withProps;
  return element;
};
